var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaution(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 51,
    viewBox: "0 0 58 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.3467 43.7396C59.2054 46.9109 56.8724 50.875 53.1602 50.875H4.83831C1.11896 50.875 -1.20325 46.9047 0.651739 43.7396L24.813 2.50242C26.6725 -0.670347 31.3299 -0.664598 33.1861 2.50242L57.3467 43.7396ZM28.9995 35.2139C26.4414 35.2139 24.3676 37.2553 24.3676 39.7734C24.3676 42.2916 26.4414 44.333 28.9995 44.333C31.5577 44.333 33.6315 42.2916 33.6315 39.7734C33.6315 37.2553 31.5577 35.2139 28.9995 35.2139ZM24.6019 18.8246L25.3489 32.3051C25.3838 32.9359 25.9137 33.4297 26.5554 33.4297H31.4437C32.0854 33.4297 32.6153 32.9359 32.6502 32.3051L33.3972 18.8246C33.4349 18.1432 32.8838 17.5703 32.1906 17.5703H25.8083C25.1152 17.5703 24.5642 18.1432 24.6019 18.8246Z",
    fill: "#550087"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaution);
export default __webpack_public_path__ + "static/media/caution.b7d746282644d1a07730bece5e85c8aa.svg";
export { ForwardRef as ReactComponent };